import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Options<TextAndPercentile>({})
export default class TextAndPercentile extends Vue {

  @Prop()
  private question!: any;

  private fieldValue = 0;
  private fieldText = '';

  private textAreaPlaceholder = 'Please enter details of \'Other\'';

  @Watch('fieldValue')
  private onFieldValueChanged(): void {
    this.question.responses[0].answerNumber = this.fieldValue;
    this.question.responses[0].value = this.fieldValue;
    this.$emit('validForm', this.validForm());
  }

  @Watch('fieldText')
  private onFieldTextChanged(): void {
    this.question.responses[0].answerTxt = this.fieldText.toString();
    // this.question.responses[0].value = this.fieldValue;
    this.$emit('validForm', this.validForm());
  }

  created(): void {
    this.question.responses[0].answerNumber = this.question.responses[0].value ?? 0;
    this.fieldValue = this.question.responses[0].value ?? 0;
    this.fieldText = this.question.responses[0].answerTxt ?? '';
  }

  private validForm(): boolean {
    return Number.isInteger(this.question.responses[0].answerNumber) && this.question.responses[0].answerTxt?.trim().length > 0;
  }

  // private keyDownFilter(event: any): void {
  //   // Filter out all non-numeric values and negative sign and 'e' and '.'
  //   if (event.keyCode === 69 || event.keyCode === 189 || event.keyCode === 190 || event.keyCode === 110) {
  //     console.log('Invalid key pressed');
  //     event.preventDefault();
  //   }
  // }

}
